






import Vue from "vue";
import { mapState } from "vuex";

export default Vue.extend({
  name: "GlobalError",
  data() {
    return {
      error: null as null | string,
    };
  },
  computed: {
    ...mapState(["globalError"]),
  },
  methods: {
    scrollTo(time: number): void {
      const posY = window.scrollY;
      let value: number = 0;

      const scrollToError = setInterval(() => {
        if (window.scrollY <= 0) {
          clearInterval(scrollToError);
        }
        value = posY / time;
        window.scrollTo(0, window.scrollY - value);
      });
    },
  },
  watch: {
    globalError(newValue: null | string) {
      this.error = newValue;

      if (newValue) {
        if (newValue.length) {
          this.scrollTo(500);
        }
      }
    },
  },
});
